"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../../Theme"));
var _dateFns = require("date-fns");
var _constant = require("../constant");
var _MobileInput = _interopRequireDefault(require("./MobileInput.proptypes"));
var _excluded = ["theme", "value", "placeholder", "dateFormat"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var StyledInput = _styledComponents.default.input.withConfig({
  displayName: "MobileInput__StyledInput",
  componentId: "sc-aaq0z1-0"
})(["outline:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border:none;position:relative;height:20px;background-color:transparent;color:transparent;-webkit-appearance:none;font-family:", ";padding:", ";&:placeholder{color:", ";opacity:0.5;}&:disabled{background-color:", ";}&::before{content:attr(data-display);color:", ";font-size:", ";line-height:", ";opacity:", ";}&:focus,&:-internal-autofill-selected{padding:", ";&::placeholder{padding:", ";}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily.default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.space.normal, " ").concat(theme.space.XXXSmall, " 0");
}, function (_ref3) {
  var theme = _ref3.theme,
    value = _ref3.value;
  return value ? theme.colors.neutral : theme.colors.greyDark;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.greyLighter;
}, function (_ref5) {
  var theme = _ref5.theme,
    value = _ref5.value;
  return value ? theme.colors.neutral : theme.colors.greyDark;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSize.normal;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.lineHeight.normal;
}, function (_ref8) {
  var value = _ref8.value;
  return value ? 1 : 0.5;
}, function (_ref9) {
  var theme = _ref9.theme;
  return "".concat(theme.space.normal, " ").concat(theme.space.XXXSmall, " 0");
}, function (_ref10) {
  var theme = _ref10.theme;
  return "".concat(theme.space.none, ";");
});
StyledInput.displayName = 'StyledInput';
var convertDate = function convertDate(value, dateFormat) {
  var isoTime = (0, _dateFns.parse)(value, _constant.ISO_DATE_FORMAT, new Date());
  return (0, _dateFns.isValid)(isoTime) ? (0, _dateFns.format)(new Date(isoTime), dateFormat) : '';
};
var MobileInput = function MobileInput(_ref11) {
  var theme = _ref11.theme,
    value = _ref11.value,
    placeholder = _ref11.placeholder,
    dateFormat = _ref11.dateFormat,
    other = (0, _objectWithoutProperties2.default)(_ref11, _excluded);
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(StyledInput, (0, _extends2.default)({
      value: value
      // eslint-disable-next-line react/prop-types
      ,
      "data-display": value && (value === null || value === void 0 ? void 0 : value.trim()) !== '' ? convertDate(value, dateFormat) : placeholder,
      type: "date"
    }, other));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
MobileInput.propTypes = _MobileInput.default.PropTypes;
MobileInput.defaultProps = _MobileInput.default.DefaultProps;
var _default = MobileInput;
exports.default = _default;